// @ts-nocheck
import { useState, useEffect } from "react"
import { useSearchParams, Link } from "react-router-dom"
import { useSearch } from "@/lib/hooks/useSearch"
import { useDebounce } from "@/lib/hooks/useDebounce"

export function SearchPageClient() {
  const [searchParams, setSearchParams] = useSearchParams()
  const q = searchParams.get("q") || ""
  const [query, setQuery] = useState(q)
  const { results, loading, search } = useSearch()
  const debounced = useDebounce(query, 350)

  useEffect(() => { if (debounced) { search(debounced); setSearchParams({ q: debounced }, { replace: true }) } }, [debounced])
  useEffect(() => { if (q) search(q) }, [])

  const hasAny = results.posts.length > 0 || results.users.length > 0 || results.topics.length > 0

  return (
    <div className="max-w-2xl mx-auto py-4">
      <div className="mb-4">
        <div className="search-bar">
          <svg className="w-4 h-4 text-muted-fg" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/>
          </svg>
          <input
            type="text" value={query} onChange={e => setQuery(e.target.value)}
            placeholder="Search SQUIDS" autoFocus
            className="bg-transparent flex-1 text-sm outline-none text-foreground placeholder:text-muted-fg"
          />
        </div>
      </div>

      {loading && <div className="panel p-8 text-center text-muted-fg text-sm">Searching...</div>}

      {!loading && q && !hasAny && (
        <div className="panel p-10 text-center">
          <p className="font-syne font-bold text-lg mb-1">No results</p>
          <p className="text-sm text-muted-fg">Nothing found for "{q}"</p>
        </div>
      )}

      {!loading && hasAny && (
        <div className="space-y-4">
          {results.topics.length > 0 && (
            <Section title="Topics">
              {results.topics.map((t: any) => (
                <Link key={t.id} to={`/topics/${t.slug}`} className="panel p-3 flex items-center gap-3 hover:border-border-strong transition-colors block">
                  <div className="w-8 h-8 rounded-full bg-brand/20 flex items-center justify-center flex-shrink-0">
                    <span className="text-brand font-bold text-xs">t/</span>
                  </div>
                  <div>
                    <p className="font-bold text-sm">t/{t.name}</p>
                    <p className="text-xs text-muted-fg">{t.post_count || 0} posts</p>
                  </div>
                </Link>
              ))}
            </Section>
          )}
          {results.users.length > 0 && (
            <Section title="People">
              {results.users.map((u: any) => (
                <Link key={u.id} to={`/profile/${u.username}`} className="panel p-3 flex items-center gap-3 hover:border-border-strong transition-colors block">
                  <div className="w-8 h-8 rounded-full bg-muted flex items-center justify-center flex-shrink-0">
                    <span className="font-bold text-xs">{(u.display_name || u.username)[0].toUpperCase()}</span>
                  </div>
                  <div>
                    <p className="font-bold text-sm">u/{u.username}</p>
                    <p className="text-xs text-muted-fg">{u.karma_score || 0} karma</p>
                  </div>
                </Link>
              ))}
            </Section>
          )}
          {results.posts.length > 0 && (
            <Section title="Posts">
              {results.posts.map((p: any) => (
                <Link key={p.id} to={`/post/${p.id}/${p.slug || "post"}`} className="panel p-3 hover:border-border-strong transition-colors block">
                  <p className="font-semibold text-sm mb-1 hover:text-brand transition-colors">{p.title}</p>
                  <p className="text-xs text-muted-fg">u/{p.users?.username} · {p.vote_score || 0} votes</p>
                </Link>
              ))}
            </Section>
          )}
        </div>
      )}
    </div>
  )
}

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div>
      <h2 className="font-syne font-bold text-xs uppercase tracking-wider text-muted-fg mb-2">{title}</h2>
      <div className="space-y-2">{children}</div>
    </div>
  )
}
